/**
 * Centralized API and Domain Configuration
 */

// The base URL for your local proxy server (Express)
// If you deploy this, change it to your production domain or use an environment variable
export const API_BASE_URL = process.env.REACT_APP_SERVER_URL || ''; // CRA proxy forwards /api/* to port 5000 in dev

// Combined API path for the proxy
export const PROXY_API_PATH = `${API_BASE_URL}/api`;

// FastAPI is proxied through Express to avoid browser CORS restrictions.
// All requests to FASTAPI_BASE are forwarded server-side to fastapiratehawk.co.uk.
export const FASTAPI_BASE = `${PROXY_API_PATH}/fastapi`;
